export type lockCallback = (isLocked: boolean) => void;

export class Lock {
    private reasons: Set<symbol | string> = new Set();

    constructor(
        private readonly onChange: lockCallback
    ) {}

    public lock(reason: symbol | string): void {
        const {reasons, onChange} = this;

        if (!reasons.size) {
            onChange(true);
        }

        reasons.add(reason);
    }

    public unlock(reason: symbol | string): void {
        const {reasons, onChange} = this;

        if (reasons.size === 1 && reasons.has(reason)) {
            onChange(false);
        }

        reasons.delete(reason);
    }

    public get isLocked(): boolean {
        return !!this.reasons.size;
    }

    public getReasons(): (symbol | string)[] {
        return [...this.reasons];
    }
};
